<template>
  <div>
    <OutReachClientsWithMostOpens
      :top-opens="topOpens"
      :loading="loading"
      @view-all="viewAll"
      @view-details="viewEventDetails"
    />
    <client-email-events-container
      v-if="showEventsModal"
      :show="true"
      :outreach-id="outreachId"
      :customer="modalData.customer"
      :edit="modalData.edit"
      @closed="onEventsModalClosed"
    />
  </div>
</template>
<script>
import ClientEmailEventsContainer from '@/components/Widgets/ClientHistory/ClientEmailEventsContainer';

export default {
  name: 'OutReachClientsWithMostOpensContainer',
  components: { ClientEmailEventsContainer },
  data() {
    return {
      showEventsModal: false,
      modalData: {},
    };
  },
  computed: {
    stats() {
      return this.$store.state.outreachs.stats;
    },
    outreachId() {
      return this.$route.params.id;
    },
    topOpens() {
      // Keep in mind that the backend trims these results.
      return this.stats.most_engaged;
    },
    loading() {
      return this.$store.state.outreachs.statsLoading;
    },
  },
  methods: {
    viewAll() {
      this.$router.push({
        name: 'ReportActivity',
        params: {
          outreach: this.outreachId,
          event: 'open',
        },
      });
    },
    viewEventDetails(customer) {
      this.modalData.customer = customer;
      this.modalData.edit = this.stats.edit;
      this.showEventsModal = true;
    },
    onEventsModalClosed() {
      this.modalData = {};
      this.showEventsModal = false;
    },
  },
};
</script>
